import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE } from '../services/api';
import { useAuth } from '../context/AuthContext';

// Só contato: permissão, equipe, username e dados de RH continuam com quem administra.
// A API valida de novo — o que está aqui é para poupar a ida ao servidor.
const CAMPOS = [
  { name: 'nome', label: 'Nome completo', type: 'text', placeholder: 'Como você aparece nos relatórios' },
  { name: 'email', label: 'E-mail', type: 'email', placeholder: 'seunome@61imoveis.com' },
  { name: 'telefone', label: 'Telefone com DDD', type: 'tel', placeholder: '(61) 99999-9999' },
  { name: 'instagram', label: 'Instagram', type: 'text', placeholder: 'seuperfil' },
];

export default function MeuPerfil() {
  const { isLogado, userData, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(() => ({
    nome: userData.nome || '', email: userData.email || '',
    telefone: userData.telefone || '', instagram: userData.instagram || '',
    descricao: userData.descricao || '',
  }));
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [erro, setErro] = useState('');

  if (!isLogado) {
    return <div className="ds-auth-wrapper"><div className="ds-auth-card">
      <h2 className="ds-auth-title">Meus dados</h2>
      <p className="ds-auth-subtitle">Entre para ver e alterar os dados da sua conta.</p>
      <button className="ds-btn ds-btn-primary ds-btn-full" onClick={() => navigate('/login')}>Entrar</button>
    </div></div>;
  }

  function alterar(campo, valor) {
    setForm(atual => ({ ...atual, [campo]: valor }));
  }

  async function salvar(e) {
    e.preventDefault();
    setMensagem(''); setErro('');
    if (!form.nome.trim()) { setErro('Informe seu nome completo.'); return; }
    setLoading(true);
    try {
      const resposta = await fetch(`${BASE}/auth/perfil`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await resposta.json();
      if (!resposta.ok) { setErro(data.error || 'Não foi possível salvar seus dados.'); return; }
      // Mantém a sessão: o token atual continua valendo, só os dados exibidos mudam.
      login(data.user, localStorage.getItem('auth_token'));
      setMensagem(data.ok || 'Dados atualizados.');
    } catch {
      setErro('Não foi possível conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ds-auth-wrapper">
      <div className="ds-auth-card ds-auth-card--wide">
        <span className="ds-auth-accent" />
        <h2 className="ds-auth-title">Meus dados</h2>
        <p className="ds-auth-subtitle">Mantenha seu contato atualizado — é por aqui que a equipe
          e os clientes falam com você.</p>

        <div className="ds-alert ds-alert-info perfil-fixos">
          <div>
            <span><strong>ID:</strong> {userData.id_usuarios || '—'}</span>
            <span><strong>Usuário:</strong> {userData.username || '—'}</span>
            <span><strong>Permissão:</strong> {userData.permissao || '—'}</span>
            <span><strong>Equipe:</strong> {userData.team || 'Sem equipe'}</span>
            <p style={{ margin: '8px 0 0' }}>Esses campos são alterados pelo administrativo.</p>
          </div>
        </div>

        <form className="ds-form" onSubmit={salvar}>
          {CAMPOS.map(campo => (
            <div className="ds-form-group" key={campo.name}>
              <label className="ds-label" htmlFor={`perfil-${campo.name}`}>{campo.label}</label>
              <input
                id={`perfil-${campo.name}`}
                className="ds-input"
                type={campo.type}
                value={form[campo.name]}
                placeholder={campo.placeholder}
                disabled={loading}
                onChange={(e) => alterar(campo.name, e.target.value)}
              />
            </div>
          ))}

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="perfil-descricao">Sobre você</label>
            <textarea
              id="perfil-descricao"
              className="ds-input"
              rows={3}
              maxLength={500}
              value={form.descricao}
              placeholder="Bairros em que atua, especialidade, idiomas…"
              disabled={loading}
              onChange={(e) => alterar('descricao', e.target.value)}
            />
          </div>

          {erro && <div className="ds-alert ds-alert-error">{erro}</div>}
          {mensagem && <div className="ds-alert ds-alert-success">{mensagem}</div>}

          <div style={{ display: 'flex', gap: 12 }}>
            <button type="submit" className="ds-btn ds-btn-primary" style={{ flex: 1 }} disabled={loading}>
              {loading ? <><span className="ds-spinner" /> Salvando...</> : 'Salvar alterações'}
            </button>
            <button type="button" className="ds-btn ds-btn-secondary" disabled={loading}
                    onClick={() => navigate('/TrocarSenha')}>Trocar senha</button>
          </div>
        </form>
      </div>
    </div>
  );
}
